import type { ReactNode } from 'react';


export type FullScreenSignupLayoutProps = {
  /** Main headline on the dark left panel */
  leftHeadline: string;
  /** Title above the form on the right */
  rightTitle: string;
  /** Supporting line under the title */
  rightSubtitle: string;
  /** Optional step indicator (e.g. dots or "Step 2 of 3") */
  stepIndicator?: ReactNode;
  /** Form and actions */
  children: ReactNode;
  /** Accent icon on the right panel */
  icon?: ReactNode;
  /** Optional max width container override (defaults to max-w-xl) */
  maxWidth?: string;
};

/**
 * Full-screen split signup layout (21st.dev / shadcn-style).
 * Uses theme `secondary` for the form panel; gradients fixed for Tailwind v3.
 */
export function FullScreenSignupLayout({
  rightTitle,
  rightSubtitle,
  children,
  maxWidth = 'max-w-xl',
}: FullScreenSignupLayoutProps) {
  return (
    <div className="min-h-screen w-full flex items-center justify-center p-4">
      <div className={`w-full relative ${maxWidth} overflow-hidden flex flex-col md:flex-row items-center justify-center shadow-xl rounded-none md:rounded-bl-[2rem]`}>
        <div className="p-6 md:p-12 w-full flex flex-col justify-center z-10 text-secondary-foreground flex-1 overflow-y-auto">
          <div className="flex flex-col items-start mb-6 md:mb-8">
            <h2 className="text-3xl font-medium mb-2 tracking-tight">{rightTitle}</h2>
            <p className="text-left opacity-80 text-sm md:text-base">{rightSubtitle}</p>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
